export enum RabbitOrigin {
  SELF_BREED = 'SELF_BREED',
  BOUGHT = 'BOUGHT',
}
